const GRADIENT = 'linear-gradient(277deg, #41F7A2 0%, #5C3DFA 50%, #41F7A2 100%)';

const LoadingSceneContentsOverlay = () => {
  return (
    <>
      <div
        className="fixed inset-0 z-[1001] bg-[rgba(0,0,0,0.30)]"
        style={{ backdropFilter: 'blur(4.949999809265137px)' }}
        aria-hidden
      />
      <div className="fixed inset-0 z-[1002] flex items-center justify-center pointer-events-none">
        <div className="pointer-events-auto flex flex-col items-center">
          <style>{`
        @keyframes gradient-flow {
          0% { background-position: 0% 50%; }
          100% { background-position: 200% 50%; }
        }
        @keyframes gradient-flow-vertical {
          0% { background-position: 0 0; }
          100% { background-position: 0 200%; }
        }
        @keyframes gradient-flow-vertical-reverse {
          0% { background-position: 0 200%; }
          100% { background-position: 0 0; }
        }
      `}</style>
          <div
            className="relative w-[244px] h-[150px]"
            style={{
              background:
                'linear-gradient(47deg, rgba(69,220,174,0.20) 0%, rgba(93,62,250,0.20) 99.08%)',
              maskImage:
                'linear-gradient(180deg, transparent 2.65%, black 48.18%, transparent 93.71%)',
              WebkitMaskImage:
                'linear-gradient(180deg, transparent 2.65%, black 48.18%, transparent 93.71%)',
              maskSize: '100% 100%',
              maskRepeat: 'no-repeat',
              maskPosition: 'center',
              WebkitMaskSize: '100% 100%',
              WebkitMaskRepeat: 'no-repeat',
              WebkitMaskPosition: 'center'
            }}
          >
            <div
              className="absolute left-0 top-0 bottom-0 w-[12px] flex flex-col justify-between items-center gap-[1.5px]"
              style={{
                backgroundImage:
                  'linear-gradient(to bottom, #45DCAE 0%, #5D3EFA 50%, #45DCAE 100%)',
                backgroundSize: '100% 200%',
                animation: 'gradient-flow-vertical 4s linear infinite'
              }}
            >
              {Array.from({ length: 38 }).map((_, index) => (
                // biome-ignore lint/suspicious/noArrayIndexKey: key is used for animation
                <div key={index} className="w-[8px] h-[1.8px] bg-black rounded-[4px]" />
              ))}
            </div>
            <div
              className="absolute right-0 top-0 bottom-0 w-[12px] flex flex-col justify-between items-center gap-[1.5px]"
              style={{
                backgroundImage: 'linear-gradient(202deg, #5D3EFA 0%, #45DCAE 50%, #5D3EFA 100%)',
                backgroundSize: '100% 200%',
                animation: 'gradient-flow-vertical-reverse 4s linear infinite'
              }}
            >
              {Array.from({ length: 38 }).map((_, index) => (
                // biome-ignore lint/suspicious/noArrayIndexKey: key is used for animation
                <div key={index} className="w-[8px] h-[1.8px] bg-black rounded-[4px]" />
              ))}
            </div>
            <div
              className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[88px] h-[88px]"
              role="img"
              aria-label="Scene Logo"
              style={{
                maskImage: `url('/assets/scene/scene_logo.png')`,
                WebkitMaskImage: `url('/assets/scene/scene_logo.png')`,
                maskSize: 'contain',
                maskRepeat: 'no-repeat',
                maskPosition: 'center',
                backgroundImage: GRADIENT,
                backgroundSize: '200% 100%',
                animation: 'gradient-flow 3s linear infinite'
              }}
            />
          </div>
          <p className="text-[20px] font-bold text-pure-white leading-[24px] mt-[19.5px]">
            나만의 씬을 불러오고 있어요...
          </p>
          <p className="text-[15px] font-medium text-pure-white leading-[18px] mt-[14px]">
            조금만 기다려주세요
          </p>
        </div>
      </div>
    </>
  );
};

export default LoadingSceneContentsOverlay;
